import { EventEmitter, Injectable, NgZone } from "@angular/core";
import { PlatformService } from "@obg/ngx.global";
import resizeObserverType from "resize-observer-polyfill";

import { ElementSize } from "./resize-observer.model";

@Injectable({
	providedIn: "root",
})
export class ResizeObserverService {
	observedElements = new WeakMap<Element, EventEmitter<ElementSize>>();
	resizeObserver: ResizeObserver | undefined;

	constructor(
		private platformService: PlatformService,
		private zone: NgZone
	) {
		if (!this.platformService.isBrowser) {
			return;
		}

		this.zone.runOutsideAngular(() => this.initResizeObserver());
	}

	registerElement(nativeElement: HTMLElement, elementSizeEmitter: EventEmitter<ElementSize>) {
		if (!this.resizeObserver) {
			return;
		}
		this.observedElements.set(nativeElement, elementSizeEmitter);
		this.resizeObserver.observe(nativeElement);
	}

	unregisterElement(nativeElement: HTMLElement) {
		if (!this.resizeObserver) {
			return;
		}
		this.resizeObserver.unobserve(nativeElement);
		this.observedElements.delete(nativeElement);
	}

	private initResizeObserver() {
		this.resizeObserver = new resizeObserverType((resizeObserverEntries: ResizeObserverEntry[]) => {
			for (const resizeObserverEntry of resizeObserverEntries) {
				const { target, contentRect } = resizeObserverEntry;
				const eventEmitter = this.observedElements.get(target);
				if (eventEmitter) {
					eventEmitter.emit({ width: contentRect.width, height: contentRect.height });
				}
			}
		});
	}
}
